import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';

export const useLeadEmailLanding = (): {
  isLandingFromEmail: boolean;
  leadId: string | null;
} => {
  const location = useLocation();

  const match = matchPath<{ leadId: string }>(location.pathname, {
    path: '/gestion-leads/proposition-leads/:leadId',
    exact: true,
  });
  const leadId = match?.params?.leadId ?? null;
  return { isLandingFromEmail: !!leadId, leadId };
};
